
import { mixins } from "vue-class-component";
import { Component } from "vue-property-decorator";

import VignetteLogo from "@/components/VignetteLogo.vue";
import { ViewAnalytics } from "@/mixins";
import { ApiService, LogService, RouterService } from "@/services";
import { ApplicationModule, getStoreModule, SessionModule } from "@/store";
import { LogLevel, LogLevels } from "@/types";

@Component({
  components: {
    VignetteLogo,
  },
  computed: {
    sentryLogLevel: {
      get(): string {
        return LogService.sentryLogLevel.label;
      },
      set(value: string) {
        LogService.sentryLogLevel = LogLevels.fromString(value);
      },
    },
    consoleLogLevel: {
      get(): string {
        return LogService.consoleLogLevel.label;
      },
      set(value: string) {
        LogService.consoleLogLevel = LogLevels.fromString(value);
      },
    },
  },
})
export default class Debug extends mixins(ViewAnalytics) {
  items!: LogLevel[];

  private applicationStore!: ApplicationModule;
  private sessionStore!: SessionModule;

  briefcaseProfileId = 30;

  // Override for PageTitle mixin
  pageName = "Debug";

  created(): void {
    this.applicationStore = getStoreModule(ApplicationModule, this.$store);
    this.sessionStore = getStoreModule(SessionModule, this.$store);
    this.items = Object.values(LogLevels.getAll());
  }

  mounted(): void {
    if (!this.sessionStore.isStaffOrSuperUser) {
      RouterService.navigateToHome(this.$router);
    }
    this.pushPageViewEvent();
  }

  getBriefcase(): void {
    ApiService.refreshBriefcase();
  }

  toggleBriefcase(): void {
    // TODO: to be refactored
    // ApiService.postBriefcaseToggleWithId(this.briefcaseProfileId);
  }

  addToBriefcase(): void {
    // TODO: to be refactored
    // ApiService.postBriefcaseToggleWithId(this.briefcaseProfileId, "add");
  }

  removeFromBriefcase(): void {
    // TODO: to be refactored
    // ApiService.postBriefcaseToggleWithId(this.briefcaseProfileId, "remove");
  }

  logDebug(): void {
    LogService.debug("Debug message.");
  }

  logInfo(): void {
    LogService.info("Info message.");
  }

  logWarn(): void {
    LogService.warn("Warning message.");
  }

  logError(): void {
    LogService.error("Error message.");
  }

  logFatal(): void {
    LogService.fatal("Fatal error message.");
  }

  callAppConfigEndpoint(): void {
    ApiService.getAppConfig();
  }

  callSessionEndpoint(): void {
    ApiService.getSession();
  }
}
